import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { createStore, combineReducers } from 'redux';
import { CookiesProvider } from 'react-cookie';
import { sessionReducer } from './reducers/session_reducer';
import App from './App';
import './index.css';

const store = createStore(combineReducers({sessionReducer}));

ReactDOM.render(
    <Provider store={store}>
        <CookiesProvider>
            <BrowserRouter>
                <Route path="/" component={App} />
            </BrowserRouter>
        </CookiesProvider>
    </Provider>,
    document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js